import * as types from '../../action-types';
import {updateEmployment as initialState } from "../../initialState";

const updateEmployment = (state=initialState, action) => {
  switch (action.type) {
    case types.UPDATE_EMPLOYMENT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_EMPLOYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPDATE_EMPLOYMENT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_EMPLOYMENT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default updateEmployment;
